import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import App from './App';
import './i18n';
import './index.css';

// Configure Amplify with runtime config
const configureAmplify = async () => {
  try {
    // Fetch runtime config
    const response = await fetch('/config.json');
    const config = await response.json();

    // Store API URL globally for use by components (remove trailing slash to avoid double slashes)
    const apiUrl = (config.VITE_API_URL || import.meta.env.VITE_API_URL || '/api').replace(/\/+$/, '');
    const wsUrl = config.VITE_WEBSOCKET_URL || import.meta.env.VITE_WEBSOCKET_URL || '';
    const userPoolId = config.VITE_COGNITO_USER_POOL_ID || import.meta.env.VITE_COGNITO_USER_POOL_ID || '';
    const identityPoolId = config.VITE_IDENTITY_POOL_ID || import.meta.env.VITE_IDENTITY_POOL_ID || '';
    window.__PAILA_CONFIG__ = {
      apiUrl,
      wsUrl: wsUrl || undefined,
      identityPoolId: identityPoolId || undefined,
      userPoolId: userPoolId || undefined,
    };

    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: config.VITE_COGNITO_USER_POOL_ID || import.meta.env.VITE_COGNITO_USER_POOL_ID,
          userPoolClientId: config.VITE_COGNITO_CLIENT_ID || import.meta.env.VITE_COGNITO_CLIENT_ID,
          loginWith: {
            oauth: {
              domain: `${config.VITE_COGNITO_DOMAIN || import.meta.env.VITE_COGNITO_DOMAIN}.auth.${config.VITE_COGNITO_REGION || import.meta.env.VITE_COGNITO_REGION || 'eu-west-2'}.amazoncognito.com`,
              scopes: ['openid', 'email', 'profile'],
              redirectSignIn: [window.location.origin + '/callback'],
              redirectSignOut: [window.location.origin + '/'],
              responseType: 'code',
            },
          },
        },
      },
    });
  } catch (error) {
    console.warn('Could not load runtime config, using env vars:', error);
    // Fallback to environment variables
    window.__PAILA_CONFIG__ = {
      apiUrl: (import.meta.env.VITE_API_URL || '/api').replace(/\/+$/, ''),
      wsUrl: import.meta.env.VITE_WEBSOCKET_URL || undefined,
    };
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
          userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
        },
      },
    });
  }
};

configureAmplify().then(() => {
  // Eruda dev console is loaded inside <DevConsoleLoader /> for allowlisted
  // staff emails only — see frontend/src/components/DevConsoleLoader.tsx.

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
});
